// @ts-check

/** The company's GST registration details, stored as site_settings keys (see backend
 * utils/billing_settings.py) so they can be filled in the moment the accountant confirms them. */

export const BILLING_KEYS = {
  gstin: 'billing_gstin',
  legalName: 'billing_legal_name',
  address: 'billing_address',
  state: 'billing_state',
};

/** @param {Array<{key: string, value?: string | null}>} settings */
export function billingFormFromSettings(settings) {
  const byKey = Object.fromEntries(settings.map((row) => [row.key, row.value]));
  return /** @type {{gstin: string, legalName: string, address: string, state: string}} */ (
    Object.fromEntries(Object.entries(BILLING_KEYS).map(([field, key]) => [field, byKey[key] || '']))
  );
}

export const isBillingConfigured = (form) => Object.values(form).every((value) => (value ?? '').trim() !== '');
